<template>
  <div class="group-message-message-list-container border-top border-gray-500">
    <div class="list-title d-flex justify-content-end p-2">
      <span class="badge badge-danger cursor-pointer" @click="close"><i class="fas fa-times"></i></span>
    </div>
    <auto-height :margin="16">
      <list
        class="px-2 overflow-auto h-100 list"
        :url="indexUrl"
      >
        <template v-slot="slotProps">
          <list-item
            :key="slotProps.item.id"
            v-bind="slotProps"
          ></list-item>
        </template>
      </list>
    </auto-height>
  </div>
</template>

<script>
import List from '../../../../components/list';
import ListItem from './email-message-list-item';
import AutoHeight from '../../../../components/auto-height';

export default {
  components: {
    List,
    ListItem,
    AutoHeight,
  },

  props: {
    emailBulkMessage: null,
  },

  computed: {
    /**
     * @return {string|null}
     */
    indexUrl() {
      return _.get(this.emailBulkMessage, 'messageListUrl');
    }
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
}
</script>
